"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteInput = SiteInput;
var _react = _interopRequireDefault(require("react"));
var _client = require("@apollo/client");
var _AutoCompleteInput = require("./AutoCompleteInput");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Q_SITE = (0, _client.gql)`
  query Sites {
    games(distinct_on: site) {
      site
    }
  }
`;
function SiteInput(props) {
  return /*#__PURE__*/_react.default.createElement(_AutoCompleteInput.AutoCompleteInput, _extends({
    query: Q_SITE,
    field: "site"
  }, props, {
    sx: {
      width: 142
    }
  }));
}